module.exports = __webpack_public_path__ + "assets/img/guide_2.70b05ecd.png";